var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "dialogByTravelAnalysis",
      attrs: {
        "append-to-body": "",
        title: "活動數據分析報告",
        top: "3%",
        visible: _vm.innerVisible,
        width: "90%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
      },
    },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-row",
            [
              _c(
                "el-form",
                {
                  staticClass: "filter-form",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "查詢" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "輸入團號或團名" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearch($event)
                          },
                        },
                        model: {
                          value: _vm.search.qry,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "qry", $$v)
                          },
                          expression: "search.qry",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-button", {
                    staticStyle: { "margin-top": "8px", "margin-left": "5px" },
                    attrs: {
                      type: "primary",
                      icon: "el-icon-search",
                      circle: "",
                      disabled: _vm.loading,
                    },
                    on: { click: _vm.handleSearch },
                  }),
                  _c("el-button", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      type: "success",
                      loading: _vm.loading,
                      circle: "",
                      icon: "el-icon-refresh-left",
                    },
                    on: { click: _vm.handleRefresh },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    size: "mini",
                    data: _vm.list,
                    border: "",
                    height: "calc(60vh - 80px)",
                    "overflow-y": "auto",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "項次", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  (_vm.pagination.page - 1) *
                                    _vm.pagination.limit +
                                    scope.$index +
                                    1
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "tourGroupNo",
                      label: "團號",
                      width: "200",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "團名", width: "450" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", [_vm._v(_vm._s(row.travelName))]),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-tag",
                                  { staticStyle: { "font-size": "14px" } },
                                  [
                                    _vm._v(" 出發 "),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            row.beginDate + " " + row.beginTime
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" - 回程 "),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            row.endDate + " " + row.endTime
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "查看報告", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.analysisReportUrl
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "info" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleViewReport(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 查看 ")]
                                )
                              : _vm._e(),
                            !scope.row.analysisReportUrl
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleGenerateReport(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 生成 ")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  !_vm.isProdMode
                    ? _c("el-table-column", {
                        attrs: { align: "center", label: "", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  !_vm.isProdMode && scope.row.analysisReportUrl
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "success",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleGenerateReport(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 重新生成 ")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2827124827
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { width: "100%", overflow: "auto" } },
                [
                  _c("pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pagination.total > 0,
                        expression: "pagination.total > 0",
                      },
                    ],
                    attrs: {
                      layout: "prev, pager, next",
                      total: _vm.pagination.total,
                      page: _vm.pagination.page,
                      limit: _vm.pagination.limit,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "page", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.pagination, "limit", $event)
                      },
                      pagination: _vm.handlePagination,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer action-buttons",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.innerVisible = false
                },
              },
            },
            [_vm._v("關 閉")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }